import { render, staticRenderFns } from "./goldStandardInfo.vue?vue&type=template&id=73040f70&scoped=true&"
import script from "./goldStandardInfo.vue?vue&type=script&lang=js&"
export * from "./goldStandardInfo.vue?vue&type=script&lang=js&"
import style0 from "./goldStandardInfo.vue?vue&type=style&index=0&id=73040f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73040f70",
  null
  
)

export default component.exports